/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext,useState,useRef ,useEffect, useCallback} from 'react';
import GlobalContext from '../../Context/GloablContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { dataService } from '../../../services/data.services';
import { transformed } from '../../../CommonMethods';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../pages/auth/authSlice';
import { InitialMaker } from '../../InitialMaker';
import AnimatedModel from '../../Animation/AnimatedModel';
import ConfirmationPrompt from '../../ConfirmationPrompt';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Sidebar, Menu, MenuItem ,SubMenu} from 'react-pro-sidebar';
import { NavObj } from '../../../config/role-based-routing';
import { AnimatePresence } from 'framer-motion';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import { Auth } from 'aws-amplify';
import SignoutModal from '../SignOutModal';
import {motion} from 'framer-motion'
import SideBarBranchModal from '../../BranchSelection/NewBranchSelectionWindow';
import { AddBranch } from '../../../redux/GlobalSlice';
import { removeAssociationSelection } from '../../../pages/ManageAssociation/AssociationSlice';
import { handleClear } from '../../../redux/commonSlice';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { ShimmerTitle } from 'react-shimmer-effects';
import { FetchBranch } from '../../../CommonMethods/FetchBranch';

const SideBar = () => {
    /* Using the useContext hook to access the state variables `isSideNavBar` and `setIsSideNavBar`
    from the `GlobalContext` context. These variables are likely used to control the visibility and
    behavior of a side navigation bar in the UI. */
    const {
        isSideNavBar, 
        setIsSideNavBar,
        swithBranch,
        selectedBranch, 
        setselectedBranch,
        rolesGlobal,
        sideNavBarObj,
        setSideNaveBarObj,
        setswithBranch,
        setshow,
        fyBtnLoading,
        setFyBtnLoading,
        swithFY,
        isPageLoadingGlobal,
        setswithFY,
        setReloadFY,
        isBranchUpdate,
        ongoingFY,
        setOngoingFY,
        fyCount, 
        setFyCount,
        studentIdCollectFee,
        setStudentCollectFee,
        isInactiveBranch, setIsInactiveBranch,
        setIsBranchSpecifTab,
        setToastmessage} = useContext(GlobalContext);
    const [topBorder, setTopBorder] = useState(false)
    const history = useNavigate()
    const dispactch = useDispatch()
    const ref = useRef();
    const { userType, branches } = useSelector((state) => state.auth);
    const GlobalChange = useSelector(state => state.GlobalData);
    const [adminOptions, setadminOptions] = useState(false)
    const [version, setVersion] = useState('');
    const [userInfo, setuserInfo] = useState({});
    const [logOutOpen, setLogOutOpen] = useState(false);
    const location = useLocation();
    const [isRole, setIsRole] = useState(false)
    const [logoutLoading, setLogoutLoading] = useState(false)
    const refSwitch = useRef(null);
    const borderNavs = ['Profile'];
    const [branchBtnLoading, setBranchBtnLoading] = useState(true)
    const [updatedBranches, setUpdatedBranches] = useState(branches)

    const isRouteMatch = (route = '') => {
        const normalizedRoute = route.split('?')[0];
        return new RegExp(`^${normalizedRoute}(/|$)`).test(location.pathname) || location.pathname.includes(normalizedRoute);
    };

    const isMenuActive = (item) => {
        if (item?.main_key && location.pathname.includes(item.main_key)) {
            return true;
        }

        if (item?.parentKey && location.pathname.includes(item.parentKey)) {
            return true;
        }

        if (item?.children?.length) {
            return item.children.some((child) => isRouteMatch(child.url));
        }

        return isRouteMatch(item?.url);
    };

    /* The above code is a JavaScript React function that fetches a navigation object based on the
    user's type and permissions. */
    const fetchNavObj = 
        useCallback(
            async() => {
                const user = await CognitoData();
                // const branches= await FetchBranch()
                let roles =  rolesGlobal?.length > 0 ? rolesGlobal : user.idToken.payload["cognito:groups"]
                let nav_obj = []
                if (user.idToken.payload['custom:user_type'] === "institution-admin") {
                    if (updatedBranches?.length > 0) {
                        nav_obj = [...NavObj[user.idToken.payload['custom:user_type']]]
                    } else {
                        if (user.idToken.payload['custom:user_type'] === "institution-admin" && updatedBranches?.length === 0) {
                            nav_obj = [...NavObj["no-branch"]]
                            setTopBorder(true)

                        }else{
                            nav_obj = [...NavObj[user.idToken.payload['custom:user_type']]]

                        }
                    }
                } else {
                    Object.values(NavObj[user.idToken.payload['custom:user_type']]).forEach(element => {
                        if (element.name === 'Profile'
                            || element.name === "Years"
                            || element.name === "Institution Users" && roles.includes("institution-users")) {
                            nav_obj.push(element)
                        } else if (element.name === 'Branches' && roles.includes('branches')) {
                            nav_obj.push(element)
                        } else if (element.roleKey && roles?.includes(element.roleKey)) {
                            nav_obj.push(element)
                        } else {
                            let filteredChildren = [];
                            if (element.children && Array.isArray(element.children)) {
                                filteredChildren = element.children.filter(child => roles.includes(child.roleKey));
                            }
                            const filteredObj = { ...element, children: filteredChildren };
                            if(filteredObj.children?.length !== 0) {
                                nav_obj.push(filteredObj)
                            }
                        }
            
                    });
                }
                setSideNaveBarObj(nav_obj);
            },
            [],
        )

    /**
     * The function `handleVerify` is used to handle the verification process and switch between
     * financial years or branches in a React application.
     */
    const handleVerify = (item, switchFY) => {
        const broadcastChannel = new BroadcastChannel('tab-reload-channel');
    
        if (switchFY) {
            setFyBtnLoading(true)
            localStorage.setItem('FY_details', JSON.stringify(item))
            broadcastChannel.postMessage({ type: 'switch_fy' });
            setswithFY(false);
            //setting reloadFY variable only if it a FY dependant tab.
            //FY dependant tab? include here
            if (['invoice-list', 'fee-collection', 'payroll', 'payables', 'voucher-entry','purchase-order',
                'grn-entry','inventory-stock-report','inventory-issue-report','collect-fee','inventory-list',
                'balance-sheet','profit-and-loss-sheet','trial-balance-sheet','receipts-and-payments'].
                some(substring => location.pathname.includes(substring))) {
                console.log('This is a FY dependent tab. reloadFY set as true')
                setReloadFY(true);
            }            
            setToastmessage('Financial Year switched successfully')
            setFyBtnLoading(false)
        } else {
            setBranchBtnLoading(true)
            const isInactive = (item.status!=undefined&&!item.status);
            const branchNameWithStatus = item.name +(isInactive?" (Inactive)":"");
            localStorage.setItem('branch_details',JSON.stringify({name:item.name,id:item.id,status:!isInactive, branchNameWithStatus:branchNameWithStatus}))
            broadcastChannel.postMessage({ type: 'switch_branch' })
            setswithBranch(false);
            setselectedBranch(JSON.parse(localStorage.getItem('branch_details')))
            getFY(item.id)
            setToastmessage('Branch switched successfully')
            history('/manage-branches/'+item.id+'*branch_details');
            setBranchBtnLoading(false)
            setIsInactiveBranch(isInactive)
        }
    
        // Close the channel when done
        broadcastChannel.close();
    }
    
    const CollectFeeCancel = async () => {
        if(studentIdCollectFee !== "" && window.location.pathname !== `/student-master/collect-fee/collect-fee-invoice/${studentIdCollectFee}`) {
            const branch_id = await GetBranchId()
            const body = {
                "cancel": true,
                "branch_id": branch_id,
                "student_id": studentIdCollectFee,
            }
            let response = await dataService.PostAPI(body, 'collect-fees');
            setStudentCollectFee("")
        }
    }
    /* The above code is a React useEffect hook that fetches the version of an application based on the
    current stage (live, staging, beta, or develop) and stores it in state and localStorage. */
    useEffect(() => {
        async function fetchVersion() {
            let stage = '';
            if (window.location.href.includes('com')) {
                stage = 'master';
            } else if (window.location.href.includes('qa')) {
                stage = 'qa';
            } else if (window.location.href.includes('beta')) {
                stage = 'beta';
            } else {
                stage = 'develop';
            }

            try {
                const result = await dataService.appVersion({
                    stage: stage,
                });
                const newVersion = result.data.data[0].school_web_application;
                if(window.location.href.includes('qa')){
                    newVersion.latest_version = 'QA'
                }
                // Store the version in state and localStorage
                setVersion(newVersion);
                localStorage.setItem('appVersion', JSON.stringify(newVersion));
            } catch (error) {
                console.error('Error fetching version:', error);
            }
        }

        // Check if version is stored in localStorage
        const storedVersion = localStorage.getItem('appVersion');
        if (storedVersion) {
            setVersion(JSON.parse(storedVersion));
        } else {
            // Fetch version on initial load or refresh
            fetchVersion();
        }

        // Attach fetchVersion to window.onload to call when the page is refreshed
        const unloadListener = (event) => {
            fetchVersion();
        };
        window.addEventListener('load', unloadListener);

        // Cleanup: Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('load', unloadListener);
        };
    }, []);

    /**
     * The function `getFY` is an asynchronous function that retrieves the ongoing financial year based
     * on the provided `id` or the branch id, and sets it as the value of `ongoingFY` state variable.
     */
    const getFY = async (id, count) => {
        const branch_id = await GetBranchId();
        const FYChannel = new BroadcastChannel('fy-channel');
        try {
            if(count === undefined){
                const res = await dataService.GetAPI(`financial-years?branch_id=${id !== undefined ? id : branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
                setOngoingFY(res?.data?.data?.financial_years[0])
                localStorage.setItem('FY_details', JSON.stringify(res?.data?.data?.financial_years[0]))
            }
            const res2 = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing,open&sort=status%2Basc`, true);
            setFyCount(res2?.data?.data?.total_count)
            FYChannel.postMessage({ type: 'fy_count', count : res2?.data?.data?.total_count })

            setFyBtnLoading(false)
            // setDropDownValue(res.data.data.financial_years);
            // setLoadingDropdown(false);
        } catch (error) {
            setFyBtnLoading(false)
            setFyCount(0)
            localStorage.removeItem("FY_details")
        }
    };

    /**
     * The function `getUserRole` checks the user's role based on their custom user type and membership
     * in certain groups.
     */
    const getUserRole = async() => {
        let val = null;
        const user = await CognitoData();
        if (user.idToken.payload["custom:user_type"] === "institution-admin") {
            setIsRole(true)
            val = JSON.parse(localStorage.getItem('branch_details')) !== null ? JSON.parse(localStorage.getItem('branch_details')) : {}
        } else if (user.idToken.payload["cognito:groups"]?.includes("financial-years")) {
            setIsRole(true)
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`branch/${branch_id}`);
            val = {name : res?.data?.data.branch_name}
        } else {
            setIsRole(false)
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`branch/${branch_id}`);
            val = {name : res?.data?.data.branch_name}
        }  
        setselectedBranch(val)
        setBranchBtnLoading(false)
    }

    /* The above code is a React useEffect hook that is used to perform side effects in a functional
    component. */
    useEffect(() => {
        const fyDetails = JSON.parse(localStorage.getItem('FY_details'));
        if (fyDetails === null || (typeof fyDetails === 'object' && Object.keys(fyDetails).length === 0)) {
            getFY();
        } else {
            setOngoingFY(JSON.parse(localStorage.getItem('FY_details')))
            setFyBtnLoading(false)
            fyCount ===0 && getFY(undefined, true);
        }
        setuserInfo(JSON.parse(localStorage.getItem('user-info')))
        getUserRole();
        fetchNavObj()
    }, [GlobalChange, isBranchUpdate]);

    /**
     * This function toggles the state of a side navigation bar.
     */
    const handleClickSideNavBar = () => {
        setIsSideNavBar(!isSideNavBar);
    } 

    /* The above code is using the `useOnClickOutside` hook in a React component. This hook is used to
    detect when a user clicks outside of a specified element, in this case, the `ref` element. When
    a click outside of the `ref` element is detected, the `setadminOptions` function is called with
    the argument `false`, which presumably hides or disables some admin options. */
    useOnClickOutside(ref,()=>{
        setadminOptions(false)

    })

    /**
     * The function `handleLogout` logs the user out, clears the state, signs the user out from the
     * authentication service, adds an empty branch, redirects to the home page, and displays a toast
     * message indicating a successful logout.
     */
    const handleLogout = () => {
        const logoutChannel = new BroadcastChannel('logout-channel');
        logoutChannel.postMessage({ type: 'logout' });
        setLogoutLoading(true)
        dispactch(handleClear())
        Auth.signOut()
        dispactch(logout());
        dispactch(AddBranch([]))
        history('/')
        setToastmessage('Sign Out successful')  
        setLogoutLoading(false)  
    }

    /* The above code is using the useEffect hook in a React component. It is checking if the current
    pathname of the location object does not include the string 'manage-association'. If it does not
    include that string, it dispatches a removeAssociationSelection action. The useEffect hook is
    triggered whenever the location object changes. */
    useEffect(() => {
        const roles = rolesGlobal;
        const fetchUserData = async () => {
            try {
                // CollectFeeCancel();  /* commented since the cancel fee collection implementation is wrong */
                if (!location.pathname.includes('manage-association')) {
                    dispactch(removeAssociationSelection());
                }
    
                const user = await CognitoData();
                if (user?.idToken?.payload["custom:user_type"] === "institution-admin") {
                    setIsRole(true);
                    fyCount === 0 && getFY(undefined, true);
                } else {
                    if (roles && roles.includes("financial-years")) {
                        setIsRole(true);
                    } else if(isRole){
                        getFY();
                        setIsRole(false);
                    }
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
    
        fetchUserData();
    }, [location]);

    useEffect(()=>{
        getFY(undefined, true)
    }, [fyBtnLoading])

    const getBranches = async() => {
        const branches= await FetchBranch()
        setUpdatedBranches(branches)
    }

    return (
        <AnimatePresence >
            <motion.div
                key="sidebar"
                className={`bg-[#031624] shadow-8xl h-screen transition-all duration-300 pt-[15px] ease-in-out pl-1.5 pr-1.5 pb-[13px]`}
                style={{
                    overflow: 'hidden',
                }}
                id={`SidebarMain_`+isSideNavBar}
            >
                <div className="flex flex-col" style={{ height: "-webkit-fill-available",'width':'100%' }}>
                    <div className="sticky top-0 left-0" style={{'display':'flex','flex-direction':isSideNavBar?'column':'row-reverse'}}>
                        <div className="pb-5">
                            <img
                                onClick={() => handleClickSideNavBar()}
                                loading="lazy"
                                decoding="async"
                                id = "menu"
                                src={!isSideNavBar ? '/images/openSidebarLogo.svg' : '/images/closedSidebarLogo.svg'}
                                alt="icon"
                                className="hamburger-menu1 cursor-pointer mx-auto"
                                style={{ 'height': '39px' }}
                            />
                        </div>
                    </div>
                    <div className="flex">
                        {!isSideNavBar ?
                            <motion.div key="sidebar-open" className='w-0 relative' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                                duration: 0.3,
                                delay: 0.4,
                                ease: [0, 0.71, 0.2, 1.01],
                            }}>
                                <Sidebar backgroundColor={"bg-[#052136]"} style={{display:'flex'}}>
                                    <div className={`bg-[#031624] pl-1 pr-1.5 pb-[13px] shadow-8xl overflow-auto fixed h-screen sidebar`} id="SidebarExpandedDiv">
                                        <div className="flex flex-col" style={{ height: "-webkit-fill-available" }}>
                                            <div className='sticky inline ease-in-out'>
                                                {branchBtnLoading ? <div className="p-3 rounded border border-[#0A426C] mb-2">
                                                    <p className="text-2xl font-bold text-[#031624]"><ShimmerTitle line={1} gap={0} variant="secondary" className="w-full mb-0"/></p>
                                                </div>
                                                    : <div>{
                                                        (Object.keys(selectedBranch)?.length > 0) &&
                                                        <>
                                                            <div class="p-2.5 rounded border border-[#0A426C] mb-2">
                                                                <button id="switch" className={`flex justify-between items-center w-full switch_btw_btn ${(userType === 'institution-user' || userType === 'institution-admin')&& updatedBranches?.length > 1 ? '' : 'cursor-default'}`}
                                                                    onClick={() => {
                                                                        if ( (userType === 'institution-user' || userType === 'institution-admin') && updatedBranches?.length > 1) {
                                                                            setswithBranch(!swithBranch)
                                                                            getBranches()
                                                                        } else {
                                                                            return;
                                                                        }

                                                                    }}>
                                                                    <span className="text-sm font-normal text-[#EEF7FE] more-lines text-start">{ JSON.parse(localStorage.getItem('branch_details'))?.branchNameWithStatus || (selectedBranch?.branchNameWithStatus != undefined ? selectedBranch?.branchNameWithStatus : selectedBranch?.name)}</span>
                                                                    {(userType==='institution-user' || userType==='institution-admin')&& updatedBranches?.length > 1 && <img src="/images/institution_profile_dropdown_active.svg" alt="icon" className="-rotate-90" title="Switch Branch" />}
                                                                </button>
                                                            </div>
                                                        </>
                                                    }
                                                    </div>}
                                                {fyBtnLoading ? <div className="p-3 rounded border border-[#0A426C] mb-2">
                                                    <p className="text-2xl font-bold text-[#031624]"><ShimmerTitle line={1} gap={0} variant="secondary" className="w-full mb-0" /></p>
                                                </div>
                                                    : <div>
                                                        {(
                                                            Object.keys(ongoingFY)?.length > 0 && (
                                                                <div className="p-2.5 rounded border border-[#0A426C] mb-2">
                                                                    <button
                                                                        id="FY-switch"
                                                                        className={`flex justify-between items-center w-full switch_btw_btn ${(isRole || userType === 'institution-admin') && fyCount > 1 ? '' : 'cursor-default'}`}
                                                                        onClick={() => {
                                                                            if ((isRole || userType === 'institution-admin') && fyCount > 1) {
                                                                                setswithFY(!swithFY);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <span className="text-sm font-normal text-[#EEF7FE] break-all break-words">
                                                                            {JSON.parse(localStorage.getItem('FY_details')) !== null
                                                                                ? `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details'))?.status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details'))?.status.slice(1)})`
                                                                                : `${ongoingFY.name} (${ongoingFY?.status.charAt(0).toUpperCase() + ongoingFY?.status.slice(1)})`}
                                                                        </span>
                                                                        {(isRole || userType === 'institution-admin') && fyCount > 1 && (
                                                                            <img src="/images/institution_profile_dropdown_active.svg" alt="icon" className="-rotate-90" />
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>}
                                            </div>
                                            <div className='h-customh1 overflow-auto offcanvas-Scrollbar' style={{'height':'calc(100vh - 250px)'}}>
                                                <ul >
                                                    <Menu iconShape="square"
                                                        menuItemStyles={{
                                                            button: ({ level, active, disabled }) => {
                                                                // only apply styles on first level elements of the tree
                                                                if (level === 0)
                                                                    return {
                                                                        color: '#ffffff',
                                                                        backgroundColor: active ? '#eecef9' : undefined,
                                                                    };
                                                            }
                                                        }}
                                                    >
                                                        {sideNavBarObj?.map((item, i) => (
                                                            <motion.li
                                                                animate={{ x: 0 }}
                                                                initial={{ x: -10 }}
                                                                transition={{ duration:0.5 }}
                                                                className={`text-f1 mb-2`} key={i + '_' + item.name}>{item.children ?

                                                                    <SubMenu
                                                                        defaultOpen={isMenuActive(item)}
                                                                        active={isMenuActive(item)} backgroundColor="transparent"
                                                                        className={`transition duration-150 ease-in-out pl-1 mb-1 ${(borderNavs.includes(item.name) && !topBorder) ? 'border-t border-[#0A426C] pt-[10px]' : ''}`}
                                                                        style={{color: !isMenuActive(item) ? '#95C0E0' : 'white'}}
                                                                        label={item.name} icon={<motion.img
                                                                            initial={{ opacity: 0, scale: 0.6 }}
                                                                            animate={{ opacity: 1, scale: 1 }}
                                                                            transition={{
                                                                                duration: 0.3,
                                                                                delay: 0.5,
                                                                                ease: [0, 0.71, 0.2, 1.01],
                                                                            }}
                                                                            loading="lazy" decoding="async" src={isMenuActive(item) ? item.active_img : item.inactive_img} alt="icon" className={`${isMenuActive(item) && item.active_img === item.inactive_img ? 'active-image' : ''}`}/>}>
                                                                        <div className=" pl-[3px] sidebar_submenu" id="profile_collapse" data-te-collapse-item>

                                                                            <motion.div 

                                                                                className='collapse_sideborder relative pl-1'>{
                                                                                    item.children.map((sub,id)=>{return (
                                                                                        <Link key={id+'sidebar'+sub.name} to={isPageLoadingGlobal ? "#" : sub.url} onClick={() => {setIsBranchSpecifTab((["My Profile", "Update Password", "Institution Profile"].includes(sub.name))) }}>
                                                                                            <MenuItem
                                                                                                active={isRouteMatch(sub.url)}
                                                                                                backgroundColor="#052136" className={`text-f1 subitem text-[#EEF7FE] p-1 inline-block w-full`} key={'sidebar' + id + sub.name}>{sub.name}</MenuItem>
                                                                                        </Link>
                                                                                    )})
                                                                                }
                                                                            </motion.div>
                                                                        </div>

                                                                    </SubMenu> :
                                                                    <Link to={item.url} onClick={() => {setIsBranchSpecifTab((["Branches", "Institution Users"].includes(item.name))) }}>
                                                                        <MenuItem active={isMenuActive(item)}
                                                                            className={`transition duration-150 ease-in-out pl-1 hover:bg-[#052136] ${borderNavs.includes(item.name) ?'border-t border-[#0A426C]':''} `} id="no-child"  
                                                                            icon={<motion.img 
                                                                                initial={{ opacity: 0, scale: 0.6 }}
                                                                                animate={{ opacity: 1, scale: 1 }}
                                                                                transition={{
                                                                                    duration: 0.3,
                                                                                    delay: 0.5,
                                                                                    ease: [0, 0.71, 0.2, 1.01],
                                                                                }}
                                                                                loading="lazy" decoding="async" 
                                                                                src={isMenuActive(item) ? item.active_img : item.inactive_img} alt="icon"  
                                                                                className={`${isMenuActive(item) && item.active_img === item.inactive_img ? 'active-image' : ''}`}
                                                                            />} 
                                                                            style={{color:'#95C0E0'}}>
                                                                            {item.name}</MenuItem></Link>
                                                                }</motion.li>
                                                        ))}
                                                    </Menu>
                                                </ul>
                                            </div> 

                        
                                            <div className="border-t border-[#0A426C] px-2 py-1 pb-0 flex items-center justify-between">
                                                <div className="flex items-center">
                                                    <span>
                                                        {Object.keys(userInfo)?.length>0 && <InitialMaker firstName={userInfo.first_name} lastName={userInfo.middle_name || ''}   />}
                                                        {/* <img loading="lazy" decoding="async" src="/images/nameImg.svg" alt="img"/> */}
                                                        {/* <div className="pl-[18px] pr-0.5">
                                            <p className="text-xs font-normal text-[#FFFFFF]">version: {version.latest_version}</p>
                                        </div> */}
                                                    </span>
                                                    <div className="pl-[18px] pr-0.5">
                                                        <p className="text-f1 text-[#FFFFFF]">{userInfo.first_name} {userInfo.middle_name}  </p>
                                                        <p className="text-xs font-normal text-[#FFFFFF]">{transformed(userInfo.role)}</p>
                                                        {/* <p className="text-xs font-normal text-[#FFFFFF]">{version?.latest_version ? `version : ${version?.latest_version}` : ''}</p> */}
                                                    </div>
                                                </div>
                                                <span>
                                                    <button type="button" className='p-3' id = "updateModal" onClick={()=>setadminOptions(!adminOptions)}>
                                                        <img loading="lazy" decoding="async" src="/images/botswhite.svg" alt="img"/>
                                                    </button>
                                                </span>
                                            </div>
                                            <div className="pb-0 flex">
                                                <p className="text-[12px] leading-[10px] text-[#4797D2] font-normal fixed bottom-0.5 pl-[10px]" style={{'bottom':'3px'}}>version: {version.latest_version}</p>
                                            </div>
                                        </div>
                                    </div> 
                                </Sidebar>
                            </motion.div>
                            :

                            <motion.div key="sidebar-closed" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                                duration: 0.3,
                                delay: 0.4,
                                ease: [0, 0.71, 0.2, 1.01],
                            }} className={`bg-[#031624] shadow-8xl pb-3 pr-2 pl-1 fixed h-screen  ${isSideNavBar===true &&swithBranch &&''}`}>
                                <div className="sticky mt-[30px] inline transition-all duration-300 delay-500 ease-in-out" style={{ 'margin-top': '9px' }}>
                                    <>{
                                        selectedBranch !== null && Object.keys(selectedBranch)?.length>0 &&

                                        <div ref={refSwitch}>
                                            <div class="p-2.5 rounded border border-[#0A426C] mb-2" title={`${selectedBranch?.name}`}>
                                                <button className={`flex ${(userType === 'institution-user' || userType === 'institution-admin')&& updatedBranches?.length > 1 ? 'justify-between' : 'justify-center'} items-center w-full switch_btw_btn`} onClick={() => { setswithBranch(!swithBranch) }}>
                                                    <span className="text-sm font-normal text-[#EEF7FE]">{<img src="/images/branches_active.svg" alt="icon" class="" />}</span>
                                                    {(userType === 'institution-user' || userType === 'institution-admin')&& updatedBranches?.length > 1 && <img src="/images/institution_profile_dropdown_active.svg" alt="icon" className="-rotate-90" />}
                                                </button>
                                            </div>
                                            {/* {swithBranch &&<SideBarBranchModal handleVerify={handleVerify} setswithBranch={setswithBranch}/>} */}
                                        </div>
                                    }</>
                                    <>{
                                        Object.keys(ongoingFY)?.length>0 &&

                                        <div ref={refSwitch}>
                                            <div className="p-2.5 rounded border border-[#0A426C] mb-2" title={`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details'))?.status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details'))?.status.slice(1)})`}>
                                                <button className={`flex ${(isRole || userType === 'institution-admin') && fyCount > 1 ? 'justify-between' : 'justify-center cursor-default'} items-center w-full switch_btw_btn`} 
                                                    onClick={() => {
                                                        if ((isRole || userType === 'institution-admin') && fyCount > 1) {
                                                            setswithFY(!swithFY);
                                                        }
                                                    }}>
                                                    <span className="text-sm font-normal text-[#EEF7FE]">{<img src="/images/FY_button.svg" alt="icon" class="" />}</span>
                                                    {(isRole || userType === 'institution-admin') && fyCount > 1 && <img src="/images/institution_profile_dropdown_active.svg" alt="icon" className="-rotate-90" />}
                                                </button>
                                            </div>
                                            {/* {swithBranch &&<SideBarBranchModal handleVerify={handleVerify} setswithBranch={setswithBranch}/>} */}
                                        </div>
                                    }
                                    </>
                                </div>
                                <div className="overflow-auto offcanvas-Scrollbar" style={{'height':'calc(100vh - 230px)'}}>
                                    <ul>
                                        {sideNavBarObj?.map((item, index) => (
                                            <li className="mb-2.5" key={item.name+index}>
                                                <Link title={item.name} to={isPageLoadingGlobal ? "#" : item?.children === undefined ? `${item?.url}` : `${item?.children[0]?.url}`} className={`flex items-center px-2.5 py-4 hover:bg-[#052136] hover:delay-75 ${isMenuActive(item) ? " bg-[#052136]" : ""}`}>
                                                    <motion.img
                                                        initial={{ opacity: 0, scale: 0.6 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        transition={{
                                                            duration: 0.3,
                                                            delay: 0.5,
                                                            ease: [0, 0.71, 0.2, 1.01],
                                                        }}
                                                        loading="lazy" decoding="async" src={isMenuActive(item) ? item.active_img : item.inactive_img} alt="icon" className={`mx-auto ${isMenuActive(item) && item.active_img === item.inactive_img ? 'active-image' : ''}`} />
                                                </Link>
                                            </li>))}
                                    </ul>
                                </div>
                                <div className="p-1.5 flex items-center justify-center">
                                    <div className=" flex items-center fixed bottom-0">
                                        <span className='border-t border-[#0A426C] bg-[#031624]'>
                                            {Object.keys(userInfo)?.length>0 && <InitialMaker collapse firstName={userInfo.first_name} lastName={userInfo.middle_name || ''} />}
                                        </span>
                                    </div>
                                </div>
                            </motion.div> 
                        }   
                    </div>
                </div>
            </motion.div>

            <div ref={ref} className={`bottom-10 absolute left-[250px] w-[178px] bg-[#FFFFFF] rounded updateNLogoutModal z-[3] border border-[#95C0E0] shadow-s13 ${adminOptions?'show':'hidden'}`}>
                <ul className='rounded'>
                    <li className="hidden">
                        <button 
                            onClick={()=>{
                                setshow(true)
                                setadminOptions(false)
                            }} 
                            type="button"
                            id="UdatePassword" 
                            className={`flex items-center py-3 pl-3 pr-2 w-full border-b border-[#95C0E0] rounded hover:bg-[#eef7fe] `} data-te-toggle="modal"
                            data-te-target="#exampleModalCenter">
                            <img loading="lazy" decoding="async" src="/images/profilecircle.svg" alt="img"/>
                            <span className="pl-3">Update Password</span>
                        </button>
                    </li>
                    <SignoutModal adminOptions={adminOptions} />
                    <li className="">
                        <button type="button" id="logoutBtn" className="flex items-center py-3 pl-[8px] pr-2 w-full hover:bg-[#eef7fe] rounded" onClick={()=>{setLogOutOpen(true)}}>
                            <img loading="lazy" decoding="async" src="/images/logout-dashboard.svg" alt="img"/>
                            <span className="pl-2" >Sign Out</span>
                        </button>
                    </li>
                </ul>
            </div>
            {((userType === 'institution-user' || userType === 'institution-admin') && selectedBranch !== null && Object.keys(selectedBranch)?.length > 0) && swithBranch && <SideBarBranchModal handleVerify={handleVerify} swithFY={false} branches={updatedBranches}/>}
            {isRole && swithFY && <SideBarBranchModal handleVerify={handleVerify} swithFY={true} selectedOngoingFY={ongoingFY} setFyCount={setFyCount} branches={updatedBranches}/>}
            {logOutOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setLogOutOpen(false)}
                        tittle= {`Sign Out`}
                        message = {`Are you sure you want to Sign Out?`}
                        buttonName = {`Sign Out`}
                        loadingActivation={logoutLoading}
                    />
                }
            />  
            }
        </AnimatePresence>
    );
}

export default SideBar;
